import { ColorPicker, ColorPickerProps, Flex, Typography } from 'antd'

type LabelColorPickerProps = {
  nameColor: string
} & ColorPickerProps

export const LabeledColorPicker = ({
  nameColor,
  ...restProps
}: LabelColorPickerProps) => {
  return (
    <Flex justify="space-between" align="center" gap={20}>
      <Typography.Text strong>{nameColor}</Typography.Text>
      <ColorPicker showText style={{ width: 106 }} {...restProps} />
    </Flex>
  )
}
